<div class="contacto">
  <h1 class="contacto__titulo">Contacto</h1>

  @if (error(); as texto) {
    <app-alerta
      tipo="error"
      titulo="No se pudo enviar"
      [mensaje]="texto"
      (cerrada)="error.set(null)"
    />
  }

  <form class="contacto__form" [formGroup]="form" (ngSubmit)="enviar()">
    <app-input-texto
      formControlName="nombre"
      label="Nombre"
      placeholder="Ingresá tu nombre"
      [textoAyuda]="mensajeDeError('nombre')"
    />

    <app-input-texto
      formControlName="email"
      label="Email"
      placeholder="Ingresá tu email"
      [textoAyuda]="mensajeDeError('email')"
    />

    <app-input-texto
      formControlName="mensaje"
      label="Mensaje"
      placeholder="Contanos en qué podemos ayudarte."
      multilinea
      [maxLargo]="mensajeMax"
      [textoAyuda]="mensajeDeError('mensaje')"
    />

    <button type="submit" class="contacto__enviar" [disabled]="!puedeEnviar()">
      {{ enviando() ? 'Enviando…' : 'Enviar' }}
    </button>
  </form>
</div>

@if (enviado()) {
  <app-modal
    icono="check"
    titulo="Tu mensaje fue enviado"
    etiquetaSecundaria="Cerrar"
    (accionSecundaria)="cerrarModal()"
    (cerrar)="cerrarModal()"
  />
}
